import React from "react";

const Input = ({
  value,
  label,
  placeholder,
  name,
  loading,
  disabled,
  type = "text",
  className,
  onInput = undefined,
  onChange = undefined,
  onBlur = undefined,
}) => {
  return (
    <div className={`input-wrapper ${className}`}>
      {label && (
        <label htmlFor={name} className="input-wrapper__label">
          {label}
        </label>
      )}
      <input
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onInput={onInput}
        disabled={disabled}
        name={name}
        className={`input-wrapper__input ${
          disabled ? "input-wrapper__input--disabled" : ""
        }`}
      />
      {loading && (
        <div className="input-wrapper__loader">
          <div className="input-wrapper__bar" />
        </div>
      )}
    </div>
  );
};

export default Input;
